import Swiper from 'swiper/bundle';
import SmoothScroll from 'smooth-scroll';
import rentalSearch from "./search";
import leafCourt from "./leafcourt";

//Functions
const getElements = (query) => {
	if (query !== undefined) {
		return Array.prototype.slice.call(document.querySelectorAll(query));
	}
}
const getIndex = el => [...el.parentNode.children].indexOf(el);

//Navigation
const setNav = () => {
	//Hamburger
	const openNav = document.querySelector(".hamburger");
	if (openNav !== null) {
		const navId = openNav.getAttribute("aria-controls");
		const nav = document.getElementById(navId);
		const toggleNav = () => {
			if (openNav.getAttribute("aria-expanded") === "false") {
				openNav.setAttribute("aria-expanded", "true");
				nav.setAttribute("aria-expanded", "true");
			} else {
				openNav.setAttribute("aria-expanded", "false");
				nav.setAttribute("aria-expanded", "false");
			}
		}
		openNav.addEventListener("click", () => {
			console.log("burger");
			toggleNav();
		});
	}
};

const swapContent = () => {
	const swapKeys = getElements(".swap_key");
	const swapTargets = getElements(".swap_target");
	if (swapKeys.length > 0 || swapTargets.length > 0) {
		swapKeys.forEach(el => {
			el.addEventListener("click", function () {
				if (el.classList.contains("active")) {
					swapKeys.forEach(el => {
						el.classList.remove("active");
					});
					const targetId = el.dataset.target;
					const target = document.getElementById(targetId);
					target.classList.remove("_show");
				} else {
					swapKeys.forEach(el => {
						el.classList.remove("active");
					});
					el.classList.add("active");
					swapTargets.forEach(el => {
						el.classList.remove("_show");
					});
					const targetId = el.dataset.target;
					// console.log(targetId);
					const target = document.getElementById(targetId);
					target.classList.add("_show");
				}
			});
		});
	};
};

const swiperThumbs = (obj) => {
	const thumbs = getElements(".swiper_thumbs ._thumb");
	if (thumbs.length !== 0) {
		thumbs.forEach(el => {
			const index = getIndex(el);
			el.addEventListener("click", function () {
				obj.slideTo(index);
			});
		});
	}
}

//Remove all table styles
const removeInlineStyle = () => {
	const tables = getElements("table, td, th");
	tables.forEach(el => {
		el.removeAttribute("style");
		el.removeAttribute("width");
		el.removeAttribute("height");
	})
}

//modal

// Functions to open and close a modal
const modalControl = function () {
	function openModal($el) {
		$el.classList.add('is-active');
	}
	
	function closeModal($el) {
		$el.classList.remove('is-active');
	}
	
	function closeAllModals() {
		(document.querySelectorAll('.modal') || []).forEach(($modal) => {
			closeModal($modal);
		});
	}
	
	// Add a click event on buttons to open a specific modal
	(document.querySelectorAll('.js-modal-trigger') || []).forEach(($trigger) => {
		const modal = $trigger.dataset.target;
		const $target = document.getElementById(modal);
		console.log($target);
	
		$trigger.addEventListener('click', () => {
			openModal($target);
		});
	});
	
	// Add a click event on various child elements to close the parent modal
	(document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button') || []).forEach(($close) => {
		const $target = $close.closest('.modal');
	
		$close.addEventListener('click', () => {
			closeModal($target);
		});
	});
	
	// Add a keyboard event to close all modals
	document.addEventListener('keydown', (event) => {
		const e = event || window.event;
	
		if (e.keyCode === 27) { // Escape key
			closeAllModals();
		}
	});
};

//Lazy loading
const lazyLoad = () => {
	const lazyLoad = Array.prototype.slice.call(document.body.querySelectorAll(".js-lazy-load"));
	const options = {
		rootMargin: "0px",
		threshold: [0]
	};
	const lazyLoader = (el) => {
		el.forEach(t => {
			if (t.intersectionRatio > 0) {
				// console.log(t)
				const target = t.target;
				const src = target.dataset.src;
				const srcset = target.dataset.srcset;
				// const imgloader = new Image();
				// imgloader.addEventListener("load",function() {
				// 	target.setAttribute("src", src);
				// 	if (srcset !== undefined) {
				// 		target.setAttribute("srcset", srcset);
				// 	}
				// 	target.classList.add("lazy-loaded");
				// });
				// imgloader.setAttribute("src", src);
				// if (srcset !== undefined) {
				// 	imgloader.setAttribute("srcset", srcset);
				// }
				target.addEventListener("load", function () {
					this.classList.add("lazy-loaded");
				});
				target.setAttribute("src", src);
				if (srcset !== undefined) {
					target.setAttribute("srcset", srcset);
				}
				isObserver.unobserve(target);
			}
		});
	};
	const isObserver = new IntersectionObserver(lazyLoader, options)
	lazyLoad.forEach(el => {
		isObserver.observe(el);
	});
}

//Cover movie ended event
const endedMovie = () => {
	const topMovie = getElements("#cover_movie");
	const endContent = getElements("#show_ended");
	topMovie.forEach(el => {
		el.addEventListener("ended", function (e) {
			el.classList.add("ended");
			endContent.forEach(el => {
				el.classList.add("ended");
			});
		})
	});
}

//Print dialog
const callPrint = () => {
	const printButtons = getElements(".call_print");
	printButtons.forEach(el => {
		el.addEventListener("click", function () {
			console.log("print");
			window.print();
		});
	});
}

//Disable null links
const disableLink = () => {
	const links = getElements('a[href*="#"]');
	links.forEach(el => {
		const anchor = el.getAttribute("href");
		if (anchor === "#") {
			el.style.cursor = "default";
			el.addEventListener("click", function (e) {
				e.preventDefault();
			});
		}
	})
}

//Contact Form 7
const cf7redirect = () => {
	document.addEventListener('wpcf7mailsent', function (event) {
		const protocol = window.location.protocol;
		const host = window.location.host;
		let path = "contact-thanks";
		if (window.location.pathname.indexOf("leafcourt_plus") > 0) {
			path = "leafcourt_plus/contact-thanks"
		}
		location = `${protocol}//${host}/${path}/`;
	}, false);
}

const init = () => {
	const carousel = new Swiper(".top_pickup_carousel", {
		direction: "horizontal",
		slidesPerView: 1.4,
		spaceBetween: 20,
		grabCursor: true,
		centeredSlides: true,
		loop: true,
		speed: 800,
		autoplay: {
			delay: 3000,
		},
		simulateTouch: true,
		effect: "slide",
		paginationClickable: true,
		pagination: {
			el: ".swiper-pagination",
		},
		breakpoints: {
			768: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		},
	});
	// const thumbCarousel = new Swiper(".rental_outline_thumb", {
	// 	direction: "horizontal",
	// 	slidesPerView: 5,
	// 	spaceBetween: 10,
	// 	centeredSlides: false,
	// 	loop: false,
	// 	simulateTouch: true,
	// 	effect: "slide",
	// });
	const rentalCarousel = new Swiper(".rental_outline_carousel", {
		direction: "horizontal",
		slidesPerView: 1,
		spaceBetween: 0,
		grabCursor: true,
		centeredSlides: true,
		loop: false,
		speed: 500,
		autoplay: {
			delay: 3000,
		},
		simulateTouch: true,
		effect: "slide",
		paginationClickable: true,
		// thumbs: {
		//   swiper: thumbCarousel,
		// },
		pagination: {
			el: ".swiper-pagination",
		},
	});
	const plafusCarousel = new Swiper(".plafus_header_cover", {
		direction: "horizontal",
		slidesPerView: 1,
		spaceBetween: 0,
		grabCursor: true,
		centeredSlides: true,
		loop: false,
		speed: 500,
		autoplay: {
			delay: 3000,
		},
		simulateTouch: true,
		effect: "slide",
		paginationClickable: true,
		pagination: {
			el: ".swiper-pagination",
		},
	});
	setNav();
	swapContent();
	swiperThumbs(rentalCarousel);
	removeInlineStyle();
	lazyLoad();
	endedMovie();
	callPrint();
	disableLink();
	cf7redirect();
	modalControl();
	rentalSearch();
	leafCourt();
	const loop = () => {
		const vscroll = document.documentElement.scrollTop;
		const gotop = document.querySelector(".gotop");
		if (gotop !== null) {
			if (vscroll >= 800) {
				gotop.classList.add("show");
			} else {
				gotop.classList.remove("show");
			}
		}
		window.requestAnimationFrame(loop);
	}
	loop();
	const scroll = new SmoothScroll('a[href*="#"]', {
		speed: 300,
		easing: 'easeOutQuint',
		header: '[data-scroll-header]'
	});
	document.addEventListener('scrollStop', function() {
		if (window.location.hash !== "") {
			const anchor = window.location.hash.split("#")[1];
			const anchorPos = document.getElementById(anchor).getBoundingClientRect().top;
			// const scrollPos = document.documentElement.scrollTop;
			const headerHeight = document.querySelector('[data-scroll-header]').offsetHeight;
			if (Math.abs(anchorPos - headerHeight) >= 5) {
				scroll.animateScroll(
					document.querySelector(window.location.hash)
				);
			}
		}
	}, false);
}

//init
if (document.readyState !== "loading") {
	init();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		init();
	})
}